import React from 'react';
import TradeCategoriesSection from '../../../sections/AdminDashboard/TradeCategories/TradeCategories';

const TradeCategories = () => {
  return <TradeCategoriesSection />;
};

export default TradeCategories;
